interface withTerminatedOn {
  terminatedOn?: string | null
}

export const isActiveMember = <T extends { employee: withTerminatedOn }>(member: T): boolean => {
  if (!member.employee.terminatedOn) return true
  return new Date(member.employee.terminatedOn).getTime() >= Date.now()
}
